import { useCurrency } from "@/context/CurrencyContext";
import { Globe } from "lucide-react";

export default function CurrencySwitcher() {
    const { currency, setCurrency, available } = useCurrency();
    return (
        <div className="flex items-center" data-testid="currency-switcher">
            <Globe className="w-3 h-3 text-muted-foreground mr-1" />
            <select
                value={currency}
                onChange={(e) => setCurrency(e.target.value)}
                className="text-xs font-semibold bg-transparent border-0 focus:outline-none cursor-pointer text-ink"
                data-testid="currency-select"
            >
                {available.map((c) => <option key={c} value={c}>{c}</option>)}
            </select>
        </div>
    );
}
